<h1 mat-dialog-title>Delete Account</h1>
<div mat-dialog-content [formGroup]="deleteAccountForm" class="modal-content">
    <h3>Are you sure you want to delete your account? You will never be able to access this data again.</h3>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="deleteAccountForm.value" color="warn">Delete</button>
</div>
